import CurrentUserContext from "@/Contexts/CurrentUser";
import { RawDate } from "@/types/globals";
import overwatchDate from "@/utils/overwatchDate";
import { Tooltip } from "@mui/material";
import { FC, ReactNode, useContext } from "react";

interface DateTimeFormatterProps {
  rawDate: string | RawDate | null | undefined;
  includeTime?: boolean;
  includeTimeTooltip?: boolean;
  tooltipTitle?: (text: string) => string;
  title?: (text: string) => string;
  startIcon?: ReactNode;
}

const DateTimeFormatter: FC<DateTimeFormatterProps> = ({
  rawDate,
  includeTime = false,
  includeTimeTooltip = false,
  tooltipTitle,
  startIcon,
  title,
}) => {
  const { dateTimePreference } = useContext(CurrentUserContext);

  const { date: dateFormat, time: timeFormat } = dateTimePreference;

  const { date } = overwatchDate(rawDate, includeTime, dateFormat, timeFormat);
  const { tooltipDate } = overwatchDate(rawDate, includeTimeTooltip, dateFormat, timeFormat);
  const tooltipText = tooltipTitle ? tooltipTitle(tooltipDate) : tooltipDate;
  const displayText = title ? title(date) : date;

  return (
    <Tooltip title={tooltipText}>
      <span style={{ display: "flex" }}>
        {startIcon && (
          <>
            {startIcon}
            {" "}
          </>
        )}
        {displayText}
      </span>
    </Tooltip>
  );
};

export default DateTimeFormatter;
